import styled from "styled-components";
import { StyledButton } from "../../Components/StyledComponents/StyledComponents";

export const StartedWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 1366px;
  flex: 1;
  overflow: hidden;
  height: 100vh;
`;

export const ImageWrapper = styled.div`
  width: 50%;
  height: 100vh;
  background: #f5f7fa;
  display: flex;
  align-content: center;
  justify-content: center;
  align-items: center;
  @media (max-width: 768px) {
    display: none;
  }
`;

export const SecondWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 22.5vh;
  margin-left: 115px;
  padding-right: 96px;
`;

export const Title = styled.h1`
  font-weight: 600;
  font-size: 34px;
  line-height: 150%;
  letter-spacing: -0.138889px;
  color: #09274a;
  margin: 0;
  padding: 0;
  font-family: "Inter";
`;

export const LogoWrapper = styled.div`
  width: 124px;
  height: 42.18px;
  margin-bottom: 20px;
`;

export const LogoImage = styled.img`
  width: 124px;
  height: 42.18px;
  margin-bottom: 20px;
`;

export const Label = styled.label`
    width: ${(props) => (props.width ? props.width : "100%")};
    line-height: 20px;
    font-weight: 500;
    font-size: 13px;
    color: #28476a;
    padding: 0;
    margin: 0;
    margin-bottom: 20px;
    font-family: "Inter";
`;

export const LoginButton = styled.button`
  position: relative;
  font-family: "Poppins";
  display: "flex";
  width: ${(props) => (props.$otherProvider ? "fit-content" : "80px")};
  height: 40px;
  align-items: center;
  align-content: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  padding: 6px 16px;
  margin-top: ${(props) => (props.$otherProvider ? "0" : "24px")};
  border-radius: 4px;
  outline: none !important;
  cursor: pointer;
  letter-spacing: 0.232143px;
  background-color: rgba(20, 115, 230, 1);
  border: 1px solid white;
  color: rgba(255, 255, 255, 1);

  &:hover {
    background-color: rgba(64, 146, 245, 1);
  }

  &.disabled {
    color: rgb(151, 163, 183);
    background-color: rgba(237, 239, 245, 1);
    pointer-events: none;
  }
`;

export const StyledInput = styled.input`
  width: 308px;
  height: 36px;
  margin-bottom: 24px;
  border: 1px solid #d6dde8;
  border-radius: 4px;
  padding: 8px 8px 8px 10px;
  box-sizing: border-box;
  &::placeholder {
    font-weight: 400;
    font-size: 13px;
    line-height: 20px;
    font-family: Inter, sans-serif;
    letter-spacing: 0.25px;
  }
  &.error,
  &:focus.error {
    border: 1px solid #CD3746;
    outline: none;
  }
`;

export const ErrorMessage = styled.div`
  margin-top: ${(props) => (props.$otherProvider ? "0" : "8px")};
  margin-bottom: ${(props) => (props.$otherProvider ? "8px" : "0")};
  color: #cd3746;
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.4px;
  text-align: left;
`;

export const FlexBox = styled.div`
  display: flex;
  margin-top: ${(props) => (props.$otherProvider ? "-8px" : "0")};
  margin-bottom: ${(props) => (props.$otherProvider ? "8px" : "0")};
`;

export const EmailSelectorWrapper = styled(StyledButton)`
  display: flex;
  flex-direction: row;
  gap: 10px;
  border-radius: 6px;
  border-width: 1px;
  padding: 16px;
  border: 1px solid #506DFF;
  cursor: pointer;
  transition: all 0.2s ease;
`;

export const EmailSelectorInnerWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  vertical-align: middle;
  color: #343C45;
  width: 121px;
`;

export const SelectLoginButtonTextWrapper = styled(Label)`
  font-family: Inter;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #28476A;
  margin-bottom: 0px;
`;

export const EmailProviderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 88px;
  gap: 12px;
  margin-bottom: 20px;
`;

export const EmailProviderOptionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 56px;
  gap: 12px;
`;

export const EmailLabelText = styled(Label)`
  font-family: Inter;
  font-weight: 500;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0px;
  color: #28476A;
  margin-bottom: 12px;
`;

export const ProductSelectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
`;

export const ProductOptionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: center;
`;

export const RadioOption = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-family: Inter;
  font-size: 13px;
  font-weight: 400;
  line-height: 20px;
  color: #28476A;
`;

export const RadioInput = styled.input`
  width: 16px;
  height: 16px;
  cursor: pointer;
  accent-color: #4285F4;
`;

export const OtpScreenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 320px;
  margin-bottom: 22.5vh;
`;

export const HelpLinkButton = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  font-size: 13px;
  color: #506dff;
  cursor: pointer;
  padding: 0;
  margin-bottom: 16px;
  &:hover {
    text-decoration: underline;
  }
`;

export const OtherPasswordScreenWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
`; 

export const StyledTooltip = styled.img`
  display: flex;
  align-items: center;
  margin: 8px 8px 0 0;
  margin: ${(props) => (props.$otherProvider ? "2px 8px 0 0" : "8px 8px 0 0")};
`;